import { LicensesRepository, ActivationCodesRepository } from 'common/repositories/index';
import eventManager from 'common/services/-RFC.eventManager';

angular.module('listeners')
    .service('LicenseListener', () => {

        eventManager.subscribe('socket:licenses', (response) => {

            if (response.verb === 'POST') {

                LicensesRepository.add(response.payload.data);

            }

            if (response.verb === 'PUT') {

                LicensesRepository.update(response.payload.data);

            }

            if (response.verb === 'DELETE') {


                if (response.payload.data.id) {

                    // Get the license that will be deleted
                    const licenseToBeDeleted =
                        LicensesRepository.getLicenseById(response.payload.data.id);

                    if (licenseToBeDeleted) {

                        // Get the activation code that will be deleted
                        const activationCodeToBeDeleted =
                            licenseToBeDeleted.relationships['activation-code'].data.id;

                        // Delete the activvation code from the repository
                        ActivationCodesRepository
                            .deleteActivationCodeById(activationCodeToBeDeleted);

                    }

                    // Delete the license code from the repository
                    LicensesRepository.deleteLicenseById(response.payload.data.id);

                }

            }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/licenses.js